/**
 * API layer da camada de versionamento da SPA.
 *
 * Isola a chamada HTTP de `version-check.js` — segue a convenção AAWZ
 * de manter `con.get/post/etc` fora dos services/components (todas as
 * chamadas a backend passam por arquivos `api*.js`).
 *
 * Fixes AAWZ-WEB-3VT.
 */

import con from '@services/connection'

export const VERSION_CHECK_ENDPOINT = '/server/spa-version/frontend'

/**
 * Consulta a versão atual da SPA frontend no backend.
 *
 * Retorna o objeto completo do connection (`{ status, value, message }`)
 * para que o caller decida o que fazer com erros. NÃO trata exceptions —
 * deixa propagar para o caller fazer rate-limit do warn (responsabilidade
 * do version-check.js).
 *
 * @returns {Promise<{ status: number, value: { versao: string, commit: string, data: string, ambiente: string } | null, message: string | null }>}
 */
export async function getSpaVersion() {
  return await con.get(VERSION_CHECK_ENDPOINT)
}
